/* eslint-disable eqeqeq */
import React, { Component, Fragment } from "react";
import { Divider, IconButton, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import FilterIcon from "mdi-material-ui/FilterOutline";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import EditTableRecord from "../../../components/EditDeleteTableRecord/EditTableRecord";
import { HttpRequest } from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import R304PushNotificationTableComponent from "./R304PushNotificationTableComponent";

class F304PushNotificationReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            showTableFilter: false,
            Data: [],
            isLoginMenu: false,
            isReload: false,
            isOpenSnackbar: false,
            snackbarMessage: "",
            snackbarSeverity: "",
        };
    }

    handleSnackbar = (isOpen, message, severity) => {
        this.setState({ isOpenSnackbar: isOpen, snackbarMessage: message, snackbarSeverity: severity });
    };

    getData = async () => {
        const res = await HttpRequest(
            "GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C304PushNotificationsView`,
            null,
            "authorizeJson"
        );
        if (res.isSuccess) {
            if (res.data != null && res.data.length > 0) {
                for (var i = 0; i < res.data.length; i++) {
                    const row = res.data[i];

                    // ── Editable only if scheduled AND scheduledAt is in the future ──


                    console.log("row", row);
                    if (row.isEditable) {
                        res.data[i].action = (
                            <EditTableRecord
                                recordId={row.id}
                                isActive={row.isActive}
                                handleChangeStatus={(recordId, isActive) =>
                                    this.handleChangeStatus(recordId, isActive)
                                }
                                // onEditURL={`#/F304PushNotificationForm/${row.id}`}
                                onEditURL={`#/F304PushNotificationForm/${res.data[i].id}`}
                                handleOpenSnackbar={(msg, severity) => this.handleSnackbar(true, msg, severity)}
                            />
                        );
                    }



                    // ── Audience label ──
                    const aType = res.data[i].audienceType;
                    res.data[i].audienceLabel =
                        aType == 0 ? "Specific User" :
                            aType == 1 ? "All Users" :
                                aType == 2 ? "Unregistered" : "-";

                    // ── Status badge ──
                    const status = res.data[i].status;
                    res.data[i].statusLabel =
                        status == 0 ? "Pending" :
                            status == 1 ? "Sent" :
                                status == 2 ? "Failed" :
                                    status == 3 ? "Partial" : "-";

                    // ── Send type label ──
                    res.data[i].sendTypeLabel =
                        res.data[i].sendType === "schedule" ? "Scheduled" : "Immediate";
                }
                this.setState({ Data: res.data || [] });
            }
        } else {
            if (res.statusCode === 401) {
                this.setState({ isLoginMenu: true });
            } else {
                this.handleSnackbar(true, res.message, "error");
            }
        }
    };

    handleChangeStatus = async (recordId, isActive) => {
        const data = new FormData();
        data.append("id", recordId);
        data.append("isActive", isActive);

        const res = await HttpRequest(
            "POST",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C304PushNotificationsStatusUpdate`,
            data,
            "authorize"
        );

        if (res.isSuccess) {
            this.handleSnackbar(true, "Status Changed", "success");
            return 1;
        } else {
            if (res.statusCode === 401) {
                this.setState({ isLoginMenu: true, isReload: false });
            } else {
                this.handleSnackbar(true, res.message, "error");
            }
            return 0;
        }
    };

    handleToggleTableFilter = () => {
        this.setState({ showTableFilter: !this.state.showTableFilter });
    };

    componentDidMount() {
        this.getData();
    }

    render() {
        const columns = [
            { name: "id", title: "ID" },
            { name: "title", title: "Title", wordWrapEnabled: true },
            { name: "body", title: "Body", wordWrapEnabled: true },
            { name: "audienceLabel", title: "Audience" },
            { name: "sendTypeLabel", title: "Send Type" },
            { name: "scheduledAt", title: "Scheduled At", wordWrapEnabled: true },
            { name: "sentAt", title: "Sent At", wordWrapEnabled: true },
            { name: "statusLabel", title: "Status" },
            { name: "action", title: "Action" },
        ];

        return (
            <Fragment>
                <LoginMenu
                    reload={this.state.isReload}
                    open={this.state.isLoginMenu}
                    handleClose={() => this.setState({ isLoginMenu: false })}
                />
                <div style={{ padding: 20 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography
                            style={{ color: "#1d5f98", fontWeight: 600, textTransform: "capitalize" }}
                            variant="h5"
                        >
                            <Tooltip title="Back">
                                <IconButton onClick={() => window.history.back()}>
                                    <ArrowBackIcon fontSize="small" color="primary" />
                                </IconButton>
                            </Tooltip>
                            Push Notifications
                        </Typography>

                        <div style={{ float: "right" }}>
                            <Tooltip title="Table Filter">
                                <IconButton
                                    style={{ marginLeft: "-10px" }}
                                    onClick={this.handleToggleTableFilter}
                                >
                                    <FilterIcon fontSize="default" color="primary" />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>

                    <Divider style={{ backgroundColor: "rgb(58, 127, 187)", opacity: "0.3" }} />

                    {this.state.Data && (
                        <R304PushNotificationTableComponent
                            data={this.state.Data}
                            columns={columns}
                            showFilter={this.state.showTableFilter}
                        />
                    )}

                    <CustomizedSnackbar
                        isOpen={this.state.isOpenSnackbar}
                        message={this.state.snackbarMessage}
                        severity={this.state.snackbarSeverity}
                        handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
                    />
                </div>
            </Fragment>
        );
    }
}

export default F304PushNotificationReport;